import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Competition } from "../../types/competition.types";
import { CompetitionsAPI } from "../../APIs/competitions.api";
import { CompetitionsEditForm } from "./competitions-edit-form";

export function CompetitionsEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [competition, setCompetition] = useState<Competition | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCompetition = async () => {
      try {
        const numberId = Number(id);
        if (!id || isNaN(numberId)) {
          navigate("/dashboard/competitions", { replace: true });
          return;
        }

        const response = await CompetitionsAPI.getCompetition(numberId);
        if (response.statusCode === 200) {
          setCompetition(response.data);
        } else {
          setError("Error al obtener la competencia: " + response.message);
        }
      } catch (err) {
        setError("Error al obtener la competencia");
      } finally {
        setLoading(false);
      }
    };

    fetchCompetition();
  }, [id, navigate]);

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;
  if (!competition) return <div>No se encontró la competencia</div>;

  return (
    <div className="p-8">
      <CompetitionsEditForm initialData={competition} />
    </div>
  );
}
